import { pickT } from "@repo/shared";
import type { TranslationTable, Widen } from "@repo/shared/types";
import { useUserLanguage } from "./context";

/**
 * QL-17 — read a locale-first translation table in the current language:
 * the user's own, or the flow's inside `FlowLanguageScope` (flow wizard).
 * Non-React code uses `pickT(T, lang)` from `@repo/shared` instead.
 */
export function useT<E extends object>(table: TranslationTable<E>): Widen<E> {
  const { userLanguage } = useUserLanguage();
  return pickT(table, userLanguage);
}
